import { AgGridReact } from 'ag-grid-react';
import { useRef } from 'react';
import { agTheme } from '~/components/ui/tables/ag/agTheme';
import { colTypesWidths } from '~/components/ui/tables/ag/columnTypes';
import {
  AuditTrailTableRow,
  colDefsAuditTrailTable,
} from './colDefsAuditTrailTable';

export type AuditTrailProps = {
  loading: boolean;
  rowData: AuditTrailTableRow[];
};

export const AuditTrailTable = ({ loading, rowData }: AuditTrailProps) => {
  const gridRef = useRef<AgGridReact<AuditTrailTableRow>>(null);

  return (
    <div style={{ height: '100%' }}>
      <AgGridReact
        rowData={rowData}
        ref={gridRef}
        loading={loading}
        columnDefs={colDefsAuditTrailTable}
        columnTypes={colTypesWidths}
        tooltipShowDelay={0}
        theme={agTheme}
        suppressContextMenu
        colResizeDefault="shift"
        suppressCellFocus
        onColumnResized={(params) => {
          if (params.finished) params.api.sizeColumnsToFit();
        }}
        autoSizeStrategy={{
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        }}
      />
    </div>
  );
};
